/**
 * What a Dedicated server (one created for this customer) is built from, where the page does not ask. The one place to change it on this
 * side; the backend mirrors it in apps/infrastructure/config/provisioning.py, which is authoritative.
 */

/** A version of an image definition in an Azure Compute Gallery, as the pipeline and Terraform name it. */
export interface GoldenImageReference {
  gallery: string
  definition: string
  /** Pinned: never `latest`. */
  version: string
  resourceGroup: string
  location: string
  /** What the page shows. */
  label: string
}

/**
 * The one golden image every dedicated RDS server is built from. Read-only: there is no image choice and no operating system choice. The
 * gallery's subscription is not here: the backend takes it from a setting (never written in code), and Terraform builds the image
 * version's resource id from these values. [CONFIRM: more image details were promised; anything missing is a placeholder.]
 */
export const RDS_GOLDEN_IMAGE: Readonly<GoldenImageReference> = Object.freeze({
  gallery: 'Traverse_GoldenImage_Gallery',
  definition: 'TraverseGlobalImage_31102026',
  version: '1.1.0',
  resourceGroup: 'rg-northcentralus-prd-trav',
  location: 'northcentralus',
  label: 'TraverseGlobalImage_31102026 (1.1.0)',
})

/** Every VM the pipeline creates uses Trusted launch. Never a field of the page: shown as a read-only line. */
export const SECURITY_TYPE = 'TrustedLaunch'
export const SECURITY_TYPE_LABEL = 'Trusted launch'

/** Every VM but the DB / SQL one has Azure Hybrid Benefit. Never a field of the page. */
export const HYBRID_BENEFIT_LABEL = 'Azure Hybrid Benefit'

/** What the RDS server section says about the server's image, security and licensing, in the order it shows them. */
export const RDS_SERVER_FACTS = Object.freeze({
  image: RDS_GOLDEN_IMAGE.label,
  securityType: SECURITY_TYPE_LABEL,
  hybridBenefit: HYBRID_BENEFIT_LABEL,
})
